import { render, staticRenderFns } from "./LegShapeGuideModal.vue?vue&type=template&id=624515da&scoped=true&"
import script from "./LegShapeGuideModal.vue?vue&type=script&lang=ts&"
export * from "./LegShapeGuideModal.vue?vue&type=script&lang=ts&"
import style0 from "./LegShapeGuideModal.vue?vue&type=style&index=0&id=624515da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624515da",
  null
  
)

export default component.exports